import addToMailchimp from 'gatsby-plugin-mailchimp';
import React, { Fragment, useState } from 'react';
import { FieldValues, useForm, UseFormRegister } from 'react-hook-form';

import { removeHtmlTags } from '../../utils/parseHtml';
import { Grid } from '../Core';
import FormField from '../Form';
import ThemedButton from '../ThemedButton';
import FormFeedbackMessage from './FeedbackMessage';
import { IQuestion } from './Newsletter';

interface IInstituteNewsletterProps {
  feedbackMessages: {
    error: string | undefined;
    success: string | undefined;
    update: string | undefined;
  };
  languageCode: string;
  questions: IQuestion[];
  submitButtonLabel: string | undefined;
}

type FormData = {
  [key: string]: string;
  'first-name': string;
  'last-name': string;
  email: string;
};

const InstituteNewsletter: FCWithClassName<IInstituteNewsletterProps> = (
  props
) => {
  const { feedbackMessages, languageCode, questions, submitButtonLabel } =
    props;
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [editProfileUrl, setEditProfileUrl] = useState<string | undefined>();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormData>();
  const onSubmit = async (formData: FormData) => {
    const listFields = {
      FNAME: formData['first-name'],
      LANGUAGE: languageCode,
      LNAME: formData['last-name'],
    };
    const result = await addToMailchimp(
      formData.email,
      listFields,
      process.env.GATSBY_MAILCHIMP_INSTITUTE
    );
    if (result.result === 'success') {
      setShowSuccess(true);
    } else if (result.msg.includes('already subscribed')) {
      const beginningOfLink = result.msg.indexOf('=') + 2;
      const endOfLink = result.msg.indexOf('>', beginningOfLink);
      const editUrl = result.msg.substring(beginningOfLink, endOfLink);
      setEditProfileUrl(editUrl);
    } else {
      console.error(result);
      setShowError(true);
    }
  };

  return (
    <form
      className="relative z-[1] w-full max-w-[1000px] m-0 lg:m-auto pb-16 "
      onSubmit={handleSubmit(onSubmit)}
    >
      {showSuccess || showError ? (
        <FormFeedbackMessage
          feedbackMessages={feedbackMessages}
          showSuccess={showSuccess}
          showError={showError}
          editProfileUrl={editProfileUrl}
        />
      ) : (
        <Fragment>
          <Grid className="grid-cols-[1fr_1fr] gap-8">
            {questions?.map((question) => {
              return (
                <FormField
                  type={question.type}
                  key={question.name}
                  name={question.name}
                  placeholder={removeHtmlTags(question.label)}
                  options={question.options}
                  register={register as unknown as UseFormRegister<FieldValues>}
                  errors={errors[question.name]}
                  required={question.required}
                  rows={question.rows}
                  toggleButtonText={question.toggleButtonText}
                  className="!border-primaryInstitute !h-[60px] lg:!h-[70px]"
                />
              );
            })}
            <ThemedButton
              type="submit"
              isLoading={isSubmitting}
              className="w-full "
            >
              {submitButtonLabel}
            </ThemedButton>
          </Grid>
        </Fragment>
      )}
    </form>
  );
};

export default InstituteNewsletter;
